unit View.Nfce.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewNfceList = class(TForm)
    btNew: TButton;
    NfceDataset: TXDataWebDataSet;
    NfceDatasetid: TIntegerField;
    NfceDatasetaliado_id: TIntegerField;
    NfceDatasetdata_base_id: TIntegerField;
    NfceDatasetchave_acesso: TStringField;
    NfceDatasetdata_transmissao: TDateTimeField;
    NfceDatasetnfce_cancelada: TBooleanField;
    NfceDatasetnfce_xml_s3: TStringField;
    NfceDatasetcodigo_interno: TIntegerField;
    NfceDatasetexcluido: TBooleanField;
    NfceDatasetinclusao: TDateTimeField;
    NfceDatasetalteracao: TDateTimeField;
    NfceDatasetexclusao: TDateTimeField;
    NfceDatasetserie: TIntegerField;
    NfceDatasetnumero: TStringField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewNfceList: TFViewNfceList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNfceList }

procedure TFViewNfceList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewNfceList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNfceList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewNfceList, AElementID, Result, @AfterCreate);
end;

procedure TFViewNfceList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewNfceList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewNfceList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      NfceDataset.Connection.Model.DefaultSchema.FindEntityType(NfceDataset.EntitySetName),
      NfceDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewNfceList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('nfce', 'active');
  TUtils.SetValorDicionarioClasses('cupons_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cupons', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    NfceDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewNfceList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.nfce.list.pagination.info');
  btNew := TButton.Create('view.nfce.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.nfce.list.table');
  cbPageSize := TComboBox.Create('view.nfce.list.cbPageSize');
  edSearch := TEdit.Create('view.nfce.list.search');
  lcPaginator := TListControl.Create('view.nfce.list.pagination');
  NfceDataset := TXDataWebDataSet.Create(Self);
  NfceDatasetid := TIntegerField.Create(Self);
  NfceDatasetaliado_id := TIntegerField.Create(Self);
  NfceDatasetdata_base_id := TIntegerField.Create(Self);
  NfceDatasetchave_acesso := TStringField.Create(Self);
  NfceDatasetdata_transmissao := TDateTimeField.Create(Self);
  NfceDatasetnfce_cancelada := TBooleanField.Create(Self);
  NfceDatasetnfce_xml_s3 := TStringField.Create(Self);
  NfceDatasetcodigo_interno := TIntegerField.Create(Self);
  NfceDatasetexcluido := TBooleanField.Create(Self);
  NfceDatasetinclusao := TDateTimeField.Create(Self);
  NfceDatasetalteracao := TDateTimeField.Create(Self);
  NfceDatasetexclusao := TDateTimeField.Create(Self);
  NfceDatasetserie := TIntegerField.Create(Self);
  NfceDatasetnumero := TStringField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  NfceDataset.BeforeLoadDFMValues;
  NfceDatasetid.BeforeLoadDFMValues;
  NfceDatasetaliado_id.BeforeLoadDFMValues;
  NfceDatasetdata_base_id.BeforeLoadDFMValues;
  NfceDatasetchave_acesso.BeforeLoadDFMValues;
  NfceDatasetdata_transmissao.BeforeLoadDFMValues;
  NfceDatasetnfce_cancelada.BeforeLoadDFMValues;
  NfceDatasetnfce_xml_s3.BeforeLoadDFMValues;
  NfceDatasetcodigo_interno.BeforeLoadDFMValues;
  NfceDatasetexcluido.BeforeLoadDFMValues;
  NfceDatasetinclusao.BeforeLoadDFMValues;
  NfceDatasetalteracao.BeforeLoadDFMValues;
  NfceDatasetexclusao.BeforeLoadDFMValues;
  NfceDatasetserie.BeforeLoadDFMValues;
  NfceDatasetnumero.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewNfceList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'chave_acesso';
      Title := 'chave_acesso';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_transmissao';
      Title := 'data_transmissao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfce_cancelada';
      Title := 'nfce_cancelada';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nfce_xml_s3';
      Title := 'nfce_xml_s3';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'serie';
      Title := 'serie';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero';
      Title := 'numero';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    NfceDataset.SetParentComponent(Self);
    NfceDataset.Name := 'NfceDataset';
    NfceDataset.EntitySetName := 'Nfce';
    NfceDataset.Connection := DMConnection.ApiConnection;
    NfceDataset.Left := 72;
    NfceDataset.Top := 144;
    NfceDatasetid.SetParentComponent(NfceDataset);
    NfceDatasetid.Name := 'NfceDatasetid';
    NfceDatasetid.FieldName := 'id';
    NfceDatasetid.Required := True;
    NfceDatasetaliado_id.SetParentComponent(NfceDataset);
    NfceDatasetaliado_id.Name := 'NfceDatasetaliado_id';
    NfceDatasetaliado_id.FieldName := 'aliado_id';
    NfceDatasetaliado_id.Required := True;
    NfceDatasetdata_base_id.SetParentComponent(NfceDataset);
    NfceDatasetdata_base_id.Name := 'NfceDatasetdata_base_id';
    NfceDatasetdata_base_id.FieldName := 'data_base_id';
    NfceDatasetdata_base_id.Required := True;
    NfceDatasetchave_acesso.SetParentComponent(NfceDataset);
    NfceDatasetchave_acesso.Name := 'NfceDatasetchave_acesso';
    NfceDatasetchave_acesso.FieldName := 'chave_acesso';
    NfceDatasetchave_acesso.Size := 255;
    NfceDatasetdata_transmissao.SetParentComponent(NfceDataset);
    NfceDatasetdata_transmissao.Name := 'NfceDatasetdata_transmissao';
    NfceDatasetdata_transmissao.FieldName := 'data_transmissao';
    NfceDatasetnfce_cancelada.SetParentComponent(NfceDataset);
    NfceDatasetnfce_cancelada.Name := 'NfceDatasetnfce_cancelada';
    NfceDatasetnfce_cancelada.FieldName := 'nfce_cancelada';
    NfceDatasetnfce_xml_s3.SetParentComponent(NfceDataset);
    NfceDatasetnfce_xml_s3.Name := 'NfceDatasetnfce_xml_s3';
    NfceDatasetnfce_xml_s3.FieldName := 'nfce_xml_s3';
    NfceDatasetnfce_xml_s3.Size := 65536;
    NfceDatasetcodigo_interno.SetParentComponent(NfceDataset);
    NfceDatasetcodigo_interno.Name := 'NfceDatasetcodigo_interno';
    NfceDatasetcodigo_interno.FieldName := 'codigo_interno';
    NfceDatasetcodigo_interno.Required := True;
    NfceDatasetexcluido.SetParentComponent(NfceDataset);
    NfceDatasetexcluido.Name := 'NfceDatasetexcluido';
    NfceDatasetexcluido.FieldName := 'excluido';
    NfceDatasetinclusao.SetParentComponent(NfceDataset);
    NfceDatasetinclusao.Name := 'NfceDatasetinclusao';
    NfceDatasetinclusao.FieldName := 'inclusao';
    NfceDatasetalteracao.SetParentComponent(NfceDataset);
    NfceDatasetalteracao.Name := 'NfceDatasetalteracao';
    NfceDatasetalteracao.FieldName := 'alteracao';
    NfceDatasetexclusao.SetParentComponent(NfceDataset);
    NfceDatasetexclusao.Name := 'NfceDatasetexclusao';
    NfceDatasetexclusao.FieldName := 'exclusao';
    NfceDatasetserie.SetParentComponent(NfceDataset);
    NfceDatasetserie.Name := 'NfceDatasetserie';
    NfceDatasetserie.FieldName := 'serie';
    NfceDatasetnumero.SetParentComponent(NfceDataset);
    NfceDatasetnumero.Name := 'NfceDatasetnumero';
    NfceDatasetnumero.FieldName := 'numero';
    NfceDatasetnumero.Size := 0;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := NfceDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    NfceDataset.AfterLoadDFMValues;
    NfceDatasetid.AfterLoadDFMValues;
    NfceDatasetaliado_id.AfterLoadDFMValues;
    NfceDatasetdata_base_id.AfterLoadDFMValues;
    NfceDatasetchave_acesso.AfterLoadDFMValues;
    NfceDatasetdata_transmissao.AfterLoadDFMValues;
    NfceDatasetnfce_cancelada.AfterLoadDFMValues;
    NfceDatasetnfce_xml_s3.AfterLoadDFMValues;
    NfceDatasetcodigo_interno.AfterLoadDFMValues;
    NfceDatasetexcluido.AfterLoadDFMValues;
    NfceDatasetinclusao.AfterLoadDFMValues;
    NfceDatasetalteracao.AfterLoadDFMValues;
    NfceDatasetexclusao.AfterLoadDFMValues;
    NfceDatasetserie.AfterLoadDFMValues;
    NfceDatasetnumero.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
